"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AggregateIconPicker;
var _react = _interopRequireWildcard(require("react"));
var _MenuIcon = _interopRequireDefault(require("../MenuIcon"));
var _AggregateMenu = _interopRequireDefault(require("./AggregateMenu"));
var _aggregationOptions = require("./aggregationOptions");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function AggregateIconPicker({
  value,
  onChange,
  onClick,
  onClose,
  options,
  ...rest
}) {
  const [open, setOpen] = (0, _react.useState)(false);
  const option = _aggregationOptions.aggregationDetailDictionary[value];
  if (!option) return null;
  const {
    Icon
  } = option;
  function handleOpen(e) {
    e.stopPropagation();
    setOpen(true);
    onClick?.(e);
  }
  function handleClose(e) {
    setOpen(false);
    onClose?.(e);
  }
  function handleChange(e, value) {
    e.stopPropagation();
    onChange(value);
    setOpen(false);
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuIcon.default, {
    open: open,
    onClick: handleOpen,
    onClose: handleClose,
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {
      fontSize: "small"
    }),
    tooltip: "Change aggregation",
    popoverProps: {
      open,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left'
      }
    },
    ...rest,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AggregateMenu.default, {
      value: value,
      onChange: handleChange,
      options: options
    })
  });
}